export default "__VITE_ASSET__M3x5i2N8__"